import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import clipboard from 'clipboard';
import VueWechatTitle from 'vue-wechat-title'
import SlideVerify from 'vue-monoplasty-slide-verify';
import PuzzleVerification from 'vue-puzzle-verification'
import JsEncrypt from 'jsencrypt'
import {Swipe,SwipeItem,Lazyload,Area,Popup,Toast, Field, CellGroup,Loading } from 'vant'
import 'vant/lib/index.css';
//密码加密 RSA加密
Vue.prototype.$jsEncrypt = function (psd) {
    let encry = new JsEncrypt();
    encry.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGTkGKVu18n+JSS/p65nLEpVCQyabgswDolBzG0g5WIjt/2LaHCAOuPzqK5hmXxClWWdWK2dWRriDVdE5kKW22JUe0IotQ4dsmEtY6b4lPdMEFVMn8gIcyLmIk/UJSv61eRVrULCwdC7SLO4q3KTuohhNUGT5ykhKXjtzmm6G2OwIDAQAB');
    let data = encry.encrypt(psd);
    return data;
}
Vue.use(Field);
Vue.use(CellGroup)
Vue.use(Area)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Loading)
Vue.use(Lazyload)
Vue.use(Toast)
Vue.use(Popup);
Vue.use(PuzzleVerification)
Vue.use(SlideVerify)
Vue.use(VueWechatTitle)
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
Vue.prototype.$axios = axios
Vue.use(ElementUI);
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')